import React from 'react';
import { useTheme } from '../App';
import ActionCard from './ActionCard';
const TopPlays = () => {
  const {
    isDarkMode
  } = useTheme();
  // Sample data for top plays
  const topPlays = [{
    title: 'Batch Alert / Missing Data',
    description: 'Why now: Multiple Batches may have incomplete data risking compliance',
    summary: '8 batches with incomplete or missing required data fields',
    confidenceScore: 94,
    valueType: 'Risks Mitigated',
    valueAmount: 5200,
    timeSaved: 35,
    size: 'M' as const,
    urgency: 'Urgent' as const
  }, {
    title: 'Expiring batches: 7 batches in next 14 days',
    description: 'Why now: Batches will expire before selling through at current rate',
    summary: '3 flower, 2 edible, 2 concentrate batches',
    confidenceScore: 92,
    valueType: 'Risks Mitigated',
    valueAmount: 3800,
    timeSaved: 45,
    size: 'L' as const,
    urgency: 'Urgent' as const
  }, {
    title: 'FOH Transfer: 12 items below safety stock',
    description: 'Why now: Several products at risk of FOH stockout in next 2 hours',
    summary: 'Includes top sellers in flower and pre-rolls',
    confidenceScore: 95,
    valueType: 'GMV Uplift',
    valueAmount: 1200,
    timeSaved: 20,
    size: 'S' as const,
    urgency: 'Medium' as const
  }];
  return <div className={`rounded-lg overflow-hidden ${isDarkMode ? 'bg-[#161b22]' : 'bg-[#f0f5f3]'} border ${isDarkMode ? 'border-[#30363d]' : 'border-gray-200'}`} data-id="element-528">
      <div className={`p-4 ${isDarkMode ? 'bg-[#161b22]' : 'bg-[#f0f5f3]'}`} data-id="element-529">
        <h2 className="text-xl font-bold" data-id="element-530">Top Plays</h2>
        <p className="text-sm opacity-80" data-id="element-531">
          Agent BLAZE's highest-impact moves right now
        </p>
      </div>
      <div className="p-4" data-id="element-532">
        {topPlays.map((play, index) => <ActionCard key={index} {...play} data-id="element-533" />)}
      </div>
    </div>;
};
export default TopPlays;